<template>
  <div class="container">
	<van-row class="top">
		  <van-col style="padding-left: 10px; height: auto; padding-right:0">
		  	<img src="@/assets/images/logo.png" class="log">
		  </van-col>
		  <van-col span="18" class="flex">
		  	<div class="pull-left" style="margin-left:5px">
						<a class="black" style="font-size: 16px; color:#575757">{{info.DicName}}</a>
						<a class="blue" style="font-size:18px;padding-top:5px;">
            <div class="fles">
                <font color="#777">ID:{{info.DicNO}}</font> 
                <div class="logos" v-if="isJudgeGrade && JudgeGrade && JudgeGrade!=0" >
                  <img src="@/assets/images/gouzi.png" class="log">
                  <span style="margin-left:5px">{{JudgeGrade}}</span>
                </div>
            </div>
            </a>
				</div>
		  </van-col>
      	<span class="badge  badge-xian"><router-link :to="{ name: 'District', params: { id: region.id, pinyin: region.RegionEnName}}" v-html="region.RegionName"></router-link></span>
		</van-row>
	</div>
</template>
<script>
export default {
  data(){
    return {
      JudgeGrade: ''
    }
  },
  components: {
  	
  },
  props: {
  	info: {
  		type: Object,
  		require: true
  	},
  	region: {
  		type: Object,
  		require: true
  	},
    isJudgeGrade: {
      default: false
    }
  },
  watch: {
    info: {
      handler (val, oldVal) {
        if(val.JudgeGrade && val.JudgeGrade != '暂无评级') {
          this.JudgeGrade = val.JudgeGrade
        }
      },
      deep: true
    }
  },
  methods: {
  },
  created(){
    this.JudgeGrade = this.info.JudgeGrade
  }
};

</script>
<style>
.log{
  width: 62px;
  height: 62px;
}
.logos{
  display: flex;
  height: 22px !important;
  margin-left: 6%;
  display: flex;
  align-items: center;
}
.logos img{
  width: 14px;
  height: 17px;
  margin: 0;
}
.logos span{
  color: #555;
  font-size: 13px;
}
.fles{
  display: flex;
}
.flex{
  width: auto;
}
</style>